import { VideoPlayer, BigPlayButton, Cover } from './VideoPlayer';
VideoPlayer.displayName = "VideoPlayerBase";
Cover.displayName = "VideoPlayer.Cover";
BigPlayButton.displayName = "VideoPlayer.BigPlayButton";
export { VideoPlayer as default, BigPlayButton, Cover };